export default __webpack_public_path__ + "1ed059025cb44602d38a31fc88e900a5.png";